import { useTranslations } from 'next-intl';
import { AvailabilityPickupTextProps } from '../types';

const AvailabilityPickupText = ({
  isDeliveryEnabled,
  isPickUpEnabled,
  className = 'ps-2'
}: AvailabilityPickupTextProps) => {
  const t = useTranslations();
  const shouldShowPickupText = isDeliveryEnabled && isPickUpEnabled;

  return (
    shouldShowPickupText && (
      <p className={className} data-testid="availability-text-pick-up">
        {t('PDP_DELIVERY_OPTIONS_AVAILABLE')}
      </p>
    )
  );
};

export default AvailabilityPickupText;
